export default function Founders() {
  const founders = [
    {
      name: "Jaya Saini",
      role: "Founder & Director",
      image: "/jaya-saini.webp",
      desc: "With a passion for sustainable agriculture, Jaya oversees operations and research partnerships, ensuring CAFE delivers reliable and scientifically validated solutions.",
    },
    {
      name: "Shlok Saini",
      role: "Founder & Director",
      image: "/shlok-saini.webp",
      desc: "Driving CAFE's vision of technology-driven agriculture, Shlok leads strategic innovation and business development to transform seed quality assessment across India.",
    },
  ];

  return (
    <section className="py-24 px-gutter bg-surface-container-low">
      <div className="max-w-container-max mx-auto">
        <div className="text-center mb-16 space-y-4">
          <span className="font-label-bold text-label-bold text-primary uppercase tracking-widest">Leadership</span>
          <h2 className="font-headline-lg text-headline-lg text-on-background">Meet Our Founders</h2>
          <p className="font-body-md text-body-md text-on-surface-variant max-w-2xl mx-auto">
            The visionaries behind CAFE — committed to revolutionizing seed quality assessment through technology and scientific excellence.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 max-w-4xl mx-auto">
          {founders.map((founder) => (
            <div
              key={founder.name}
              className="group relative bg-white rounded-2xl overflow-hidden shadow-sm border border-outline-variant/30 hover:shadow-xl transition-all duration-300"
            >
              {/* Photo */}
              <div className="relative overflow-hidden">
                <div className="aspect-[4/5] overflow-hidden">
                  <img
                    src={founder.image}
                    alt={founder.name}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-data-teal/80 via-transparent to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <h3 className="font-headline-md text-headline-md text-white">{founder.name}</h3>
                  <p className="font-label-bold text-label-bold text-cucumber-blossom uppercase tracking-wider">{founder.role}</p>
                </div>
              </div>

              {/* Info */}
              <div className="p-6 space-y-4">
                <p className="font-body-md text-body-md text-on-surface-variant">{founder.desc}</p>
                <div className="flex items-center gap-3 pt-2">
                  <div className="w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center">
                    <span className="material-symbols-outlined text-primary text-[18px]">verified</span>
                  </div>
                  <span className="font-label-mono text-label-mono text-on-surface-variant">DIRECTOR • CAFE</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
